import { render, staticRenderFns } from "./PopupTaskDetails.vue?vue&type=template&id=19e5fe6f"
import script from "./PopupTaskDetails.vue?vue&type=script&lang=ts"
export * from "./PopupTaskDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports